import React from "react";

import VideoItem from "../VideoItem";

const VideoList = ({ videos, onVideoSelect }) => {
  //we passed in videos via props
  //map over the videos array to return a new array and save to renderList
  const renderedList = videos.map((video) => {
    return (
      <VideoItem
        key={video.id.videoId}
        onVideoSelect={onVideoSelect}
        video={video}
      />
    );
  });

  return <div className="video-list">{renderedList}</div>;
};

export default VideoList;
